import {Component, OnInit, Input} from '@angular/core';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {SasisopaService} from '../../../../../services/sasisopa.service';
import {PoliticsEditComponent} from '../edit/politics-edit.component';
import {NbDialogService} from '@nebular/theme';
import {PoliticsCreateComponent} from '../create/politics-create.component';
import * as moment from 'moment';
import { getYearsForSelect } from '../../../../../helpers/utils';

@Component({
  selector: 'ngx-politics-index',
  templateUrl: './politics-index.component.html',
  styleUrls: ['./politics-index.component.scss'],
})
export class PoliticsIndexComponent implements OnInit {
  @Input() stationId: string;
  loading = false;
  today = new Date();
  year = moment(this.today).format('YYYY');
  years = getYearsForSelect();
  target: any = [];
  data = [];
  settings: any = {
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.svg" class="mx-1 hover-cursor-pointer" width="35px">'
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.svg" class="mx-1 hover-cursor-pointer" width="35px">'
        },
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.svg" class="mx-1 hover-cursor-pointer" width="25px">'
        },
      ],
    },
    pager: {perPage: 15},
    columns: {
      // politic: {title: 'Política', filter: true, valuePrepareFunction: (value) => `${value.slice(0, 50)}...` },
      responsable: {title: 'Responsable', filter: true},
    },
    noDataMessage: 'Sin registros',
  };

  constructor(
    private sasisopaService: SasisopaService,
    private dialogService: NbDialogService,
  ) {
  }

  async ngOnInit() {
    await this.getTargets();
  }

  async getTargets() {
    this.loading = true;
    const [err, result] = await this.sasisopaService.getPolitics(this.stationId, this.year);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde]', 'error');
    this.data = result;
  }

  async downloadFormat(politicId) {
    await this.sasisopaService.downloadSasisopaFormat({stationId: this.stationId, procedure: '1',  format: '1', modelId: politicId});
  }

  async deleteTarget(targetId: any) {
    this.loading = true;
    const [error, response] = await this.sasisopaService.deletePolitic(targetId);
    if (error) {
      this.loading = false;
      ;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Política borrada con éxito', 'success');
    await this.getTargets();
  }

  onCustom($event: any) {
    if ($event.action === 'edit') {
      this.target = $event.data;
      this.showModalCreateFormat();
    } else if ($event.action === 'delete') {
      this.deleteTarget($event.data.id);
      this.target = $event.data;
      // @ts-ignore
    } else {
      this.downloadFormat($event.data.id);
    }
  }

  async showModalCreateFormat() {
    this.dialogService.open(PoliticsEditComponent, {
      hasScroll: true,
      context: {
        target: this.target,
      },
    }).onClose.subscribe(response => response ? this.ngOnInit() : null);
  }

  async showModalCreateObjectives() {
    this.dialogService.open(PoliticsCreateComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(response => response ? this.ngOnInit() : null);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
